type Params =
  | {
      event: "download-file";
      payload: {
        url: string;
        filename?: string;
        as: "pic" | "video" | "audio" | "file";
      };
    }
  | {
      event: "check-chats-permission";
      payload: undefined;
    }
  | {
      event: "toggle-orientation";
      payload: {
        orientation: "landscape" | "portrait";
      };
    }
  | {
      event: "history-change";
      payload: {
        currentPosition: number;
        pathname: string;
      };
    }
  | {
      event: "onload";
      payload: undefined;
    }
  | {
      event: "auth-token";
      payload: {
        token: string;
      };
    }
  | {
      event: "language-change";
      payload: {
        language: string;
      };
    }
  | {
      event: "start-pip";
      payload: {
        url: string;
        paused: boolean;
      };
    }
  | {
      event: "exit-pip";
      payload: undefined;
    };

export default function postMsgToNative<T extends Params["event"]>(
  event: T,
  payload?: Extract<Params, { event: T }>["payload"],
) {
  window.ReactNativeWebView?.postMessage(JSON.stringify({ event, payload }));
}
